export const membershipStatuses = {
    ACTIVE: 'active',
    LOCKED: 'locked',
    PAYMENT_FAILED: 'payment-failed',
    CANCELLED: 'cancelled',
    PRE_PAID_EXPIRED: 'prepaid-expired'
};
export const membershipPlans = {
    LEGACY_LIMITED_FREE: 'legacy-limited-free',
    LEGACY_ONE_YEAR_FREE: 'legacy-1-year-free',
    LEGACY_TWO_YEAR_PREPAID: 'legacy-2-year-prepaid',
    LEGACY_ONE_YEAR_PREPAID: 'legacy-1-year-prepaid',
    UNLIMITED_FREE: 'unlimited-free',
    ORGANIZATION_MEMBER: 'organization-member'
};
export const HERO_PLANS = {
    pending: undefined,
    basic: 0,
    annual: 0,
    biannual: 0,
    'basic-extended-trial': 0,
    'super-hero': 1,
    'super-hero-plus': 2,
    'legacy-limited-free': 3,
    'legacy-1-year-free': 4,
    'legacy-1-year-prepaid': 4,
    'legacy-2-year-prepaid': 4,
    'unlimited-free': 4,
    'organization-member': 4
};
export const USED_PLANS = ['basic', 'monthly', 'annual', 'biannual', 'basic-extended-trial'];
export const BENEFIT_LIST = [
    {
        text: 'Award-winning dispenser',
        keys: USED_PLANS
    },
    {
        text: 'Med management app',
        keys: USED_PLANS
    },
    {
        text: 'Refills with free delivery',
        keys: USED_PLANS
    },
    {
        text: '24/7 live support',
        keys: USED_PLANS
    },
    {
        text: 'Proactive adherence monitoring',
        keys: ['super-hero']
    },
    {
        text: 'Proactive device monitoring',
        keys: ['super-hero']
    },
    {
        text: 'Gap day prevention',
        keys: ['super-hero']
    },
    {
        text: 'And much more',
        keys: ['super-hero']
    },
    {
        text: 'Medication reminders',
        keys: ['legacy-1-year-free', 'legacy-1-year-prepaid', 'legacy-2-year-prepaid']
    },
    {
        text: 'Today Screen',
        keys: ['legacy-1-year-free', 'legacy-1-year-prepaid', 'legacy-2-year-prepaid']
    },
    {
        text: 'Daily Journal',
        keys: ['legacy-1-year-free', 'legacy-1-year-prepaid', 'legacy-2-year-prepaid']
    },
    {
        text: 'Drug Interactions',
        keys: ['legacy-1-year-free', 'legacy-1-year-prepaid', 'legacy-2-year-prepaid']
    },
    {
        text: 'Hero Fill',
        keys: ['legacy-1-year-free', 'legacy-1-year-prepaid', 'legacy-2-year-prepaid']
    },
    {
        text: 'Statistics',
        keys: ['legacy-1-year-free', 'legacy-1-year-prepaid', 'legacy-2-year-prepaid']
    }
];
export const getPerPlanLabel = (planKey, isAdverb) => {
    const lowerCasePlanKey = planKey === null || planKey === void 0 ? void 0 : planKey.toLowerCase();
    if (lowerCasePlanKey === 'annual') {
        return isAdverb ? 'yearly' : 'Year';
    }
    if (lowerCasePlanKey === 'biannual') {
        return '24 Months';
    }
    return isAdverb ? 'monthly' : 'Month';
};
export const getMembershipPlanAction = (current_key, selected_key) => {
    const currentPlanScore = HERO_PLANS[current_key];
    const selectedPlanScore = HERO_PLANS[selected_key];
    if (currentPlanScore !== undefined && selectedPlanScore !== undefined) {
        if (currentPlanScore < selectedPlanScore) {
            return 'upgrade';
        }
        else if (currentPlanScore > selectedPlanScore) {
            return 'disgrade';
        }
    }
    return 'current';
};
export const getMembershipPlanActionCopy = (current_key, selected_key) => {
    switch (getMembershipPlanAction(current_key, selected_key)) {
        case 'upgrade':
            return 'Upgrade to ';
        case 'disgrade':
            return 'Downgrade to ';
        default:
            return '';
    }
};
export const checkIfUserWithoutDeviceSerialNumber = (membership_details) => {
    return (membership_details &&
        membership_details.current_plan &&
        membership_details.current_plan.key === 'pending');
};
export const checkIfUnlimitedFree = (membership_details) => {
    return (membership_details &&
        membership_details.current_plan &&
        membership_details.current_plan.key === membershipPlans.UNLIMITED_FREE);
};
export const checkIfOrganizationMember = (membership_details) => {
    return (membership_details &&
        membership_details.current_plan &&
        membership_details.current_plan.key === membershipPlans.ORGANIZATION_MEMBER);
};
export const getMembershipWarningStatus = (membership_details) => {
    return (membership_details &&
        !!membership_details.status &&
        [
            membershipStatuses.LOCKED,
            membershipStatuses.PAYMENT_FAILED,
            membershipStatuses.CANCELLED,
            membershipStatuses.PRE_PAID_EXPIRED
        ].includes(membership_details.status));
};
// LEGACY USERS
export const checkIfLegacyLimitedFree = (membership_details) => {
    return (membership_details &&
        membership_details.current_plan &&
        membership_details.current_plan.key === membershipPlans.LEGACY_LIMITED_FREE);
};
export const checkIfLegacyUser = (membership_details) => membership_details &&
    membership_details.current_plan &&
    [
        membershipPlans.LEGACY_LIMITED_FREE,
        membershipPlans.LEGACY_ONE_YEAR_FREE,
        membershipPlans.LEGACY_TWO_YEAR_PREPAID,
        membershipPlans.LEGACY_ONE_YEAR_PREPAID,
        membershipPlans.UNLIMITED_FREE
    ].includes(membership_details.current_plan.key);
export const checkIfLegacyPrepaid = (membership_details) => membership_details &&
    membership_details.current_plan &&
    membership_details.is_prepaid &&
    [
        membershipPlans.LEGACY_ONE_YEAR_FREE,
        membershipPlans.LEGACY_TWO_YEAR_PREPAID,
        membershipPlans.LEGACY_ONE_YEAR_PREPAID
    ].includes(membership_details.current_plan.key);
export const checkIfLegacyMonthly = (membership_details) => membership_details &&
    membership_details.current_plan &&
    [
        membershipPlans.LEGACY_ONE_YEAR_FREE,
        membershipPlans.LEGACY_TWO_YEAR_PREPAID,
        membershipPlans.LEGACY_ONE_YEAR_PREPAID
    ].includes(membership_details.current_plan.key);
export const checkIfLegacyUserLock = (membership_details) => membership_details &&
    membership_details.current_plan &&
    membership_details.status === membershipStatuses.LOCKED &&
    [
        membershipPlans.LEGACY_ONE_YEAR_FREE,
        membershipPlans.LEGACY_TWO_YEAR_PREPAID,
        membershipPlans.LEGACY_ONE_YEAR_PREPAID
    ].includes(membership_details.current_plan.key);
// REGULAR USERS
export const checkIfUserMembershipLocked = (membership_details) => {
    return membership_details.status === membershipStatuses.LOCKED;
};
export const checkIfUserMembershipCancelled = (membership_details) => {
    return membership_details.status === membershipStatuses.CANCELLED;
};
export const checkIfUserMembershipExpired = (membership_details) => {
    return membership_details.status === membershipStatuses.PRE_PAID_EXPIRED;
};
export const checkIfUserMembershipPaymentFailed = (membership_details) => {
    return membership_details.status === membershipStatuses.PAYMENT_FAILED; // FRE update payment method
};
export const checkIfPickedPlanLegacyLimitedFree = (picked_plan) => {
    return picked_plan && picked_plan.key === membershipPlans.LEGACY_LIMITED_FREE;
};
export const checkIfPickedPlanLegacyMonthly = (picked_plan) => {
    return (picked_plan &&
        [
            membershipPlans.LEGACY_ONE_YEAR_FREE,
            membershipPlans.LEGACY_TWO_YEAR_PREPAID,
            membershipPlans.LEGACY_ONE_YEAR_PREPAID
        ].includes(picked_plan.key));
};
export const shouldShowMembership = (membership) => {
    return (!!membership &&
        !checkIfOrganizationMember(membership) &&
        !checkIfUserWithoutDeviceSerialNumber(membership) &&
        !checkIfUnlimitedFree(membership));
};
//# sourceMappingURL=index.js.map